import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SimpleAssessment } from "@/schema/console/simple-assessments/SimpleAssessment";
import { Copy20Regular, DocumentAdd20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CreateTestButtonProps {
  currentActiveTest?: SimpleAssessment;
}

function CreateTestButton({ currentActiveTest }: CreateTestButtonProps) {
  const navigate = useNavigate();
  const hasActiveTest = !!currentActiveTest;
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button>{t("create-new-test")}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() => {
            navigate(`/console/simple-assessments/create?duplicate=false`);
          }}
        >
          <DocumentAdd20Regular className="mr-1" />
          <span>{t("start-from-scratch")}</span>
        </DropdownMenuItem>
        {hasActiveTest && (
          <DropdownMenuItem
            onClick={() => {
              navigate(`/console/simple-assessments/create?duplicate=true`);
            }}
          >
            <Copy20Regular className="mr-1" />
            <span>{t("duplicate-current-test")}</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateTestButton;
